// src/utils/localCart.js
const LOCAL_CART_KEY = 'pending_enquiry_items'

export const getLocalCart = () => {
  const raw = localStorage.getItem(LOCAL_CART_KEY)
  const items = raw ? JSON.parse(raw) : []
  // ★ 兜底排序：按 localId 倒序（localId = Date.now() + Math.random()，越大越新）
  return items.sort((a, b) => (b.localId || 0) - (a.localId || 0))
}

export const saveLocalCart = (items) => {
  localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items))
}

export const addToLocalCart = (productId, customText, imageUrl, categoryName, productName) => {
  const items = getLocalCart()
  const exists = items.some(item => item.ProductID === productId)
  if (exists) return false

  const newItem = {
    localId: Date.now() + Math.random(),
    ProductID: productId,
    image: imageUrl,
    category: categoryName,
    name: productName,
    customizationText: customText || ''
  }

  // ★ 关键：unshift 放到数组头部，新加的在最前面
  items.unshift(newItem)
  saveLocalCart(items)
  return true
}

export const removeFromLocalCart = (localId) => {
  let items = getLocalCart()
  items = items.filter(item => item.localId !== localId)
  saveLocalCart(items)
}

export const updateLocalCartCustomization = (localId, text) => {
  let items = getLocalCart()
  const target = items.find(item => item.localId === localId)
  if (target) target.customizationText = text
  saveLocalCart(items)
}

export const clearLocalCart = () => {
  localStorage.removeItem(LOCAL_CART_KEY)
}